import * as React from 'react';

interface IProps {
	customFieldValues?: CustomFieldValueDTO[];
}

const CustomFieldInfo = (props: IProps) => {
	if (props.customFieldValues === undefined) {
		return null;
	}

	const customFieldInfo = props.customFieldValues!.map(cf => (
			<React.Fragment key={cf.name}>
				<p className="d-inline-block mr-3">
					<span className="font-weight-bold">{cf.name}:</span> {cf.value}
				</p>
			</React.Fragment>
	
		));

	return (
		<React.Fragment>
			{customFieldInfo}
		</React.Fragment>
	);
};

export default CustomFieldInfo;